import { 
    SET_CURPAGE_DATA,
    RESET_CURPAGE, 
    RESET_ALL_DATA,
    SET_CURPAGE_IS_ERROR, 
    SET_LOGIN_DATA,
    SET_PAYMENT_DATA,
    SET_TRANSACTION_DATA,
    SET_LISTENER_START,
    SET_LISTENER_QR_REGISTERED,
    SET_SESSION_EXPIRED,
    SET_MAX_LOGIN_TRIES_REACHED,
    SET_MAX_2FA_TRIES_REACHED,
    SET_MERCHANT_INFO,
    SET_REDIRECT_URL,
    SET_QUERY_FAILED,
    SET_PAYMENT_ERROR,
    SET_PAYMENT_STATUS,
    SET_MAX_RESEND_OTP_REACHED,
    SET_DEFAULT_ERROR,
    SET_2FA_OTP,
    STOP_QUERY_POLLING,
    USER_TRIGGERED_LEAVE,
    SET_IS_LOADING,
    SET_IS_VERIFYING,
    SET_IS_GUEST,
    SET_IS_SKIP_LOGIN,
    SET_TOPUP_DATA
} from '../constants/actionType';

export const updateCurPageData = (data) => ({ type: SET_CURPAGE_DATA, data });
export const resetPageState = () => ({ type: RESET_CURPAGE });
export const setCurPageIsError = (data) => ({ type: SET_CURPAGE_IS_ERROR, data });

export const updateLoginData = (data) => ({ type: SET_LOGIN_DATA, data });
export const updatePaymentData = (data) => ({ type: SET_PAYMENT_DATA, data });
export const updateTransactionData = (data) => ({ type: SET_TRANSACTION_DATA, data });

export const resetAllData = (data) => ({ type: RESET_ALL_DATA, data });

export const setListenerStart = (data) => ({ type: SET_LISTENER_START, data });
export const setListenerQRRegistered = (data) => ({ type: SET_LISTENER_QR_REGISTERED, data });
export const setSessionExpired = (data) => ({ type: SET_SESSION_EXPIRED, data });

export const setMaxLoginTriesReached = (data) => ({ type: SET_MAX_LOGIN_TRIES_REACHED, data });
export const setMax2FATriesReached = (data) => ({ type: SET_MAX_2FA_TRIES_REACHED, data });
export const setMaxResendOTPReached = (data) => ({ type: SET_MAX_RESEND_OTP_REACHED, data });

export const setMerchantInfo = (data) => ({ type: SET_MERCHANT_INFO, data });
export const setRedirectURL = (data) => ({ type: SET_REDIRECT_URL, data });
export const setQueryFailed = (data) => ({ type: SET_QUERY_FAILED, data });
export const setDefaultError = (data, errorDetails) => ({ type: SET_DEFAULT_ERROR, data: {
    status: data,
    errorDetails,
}});

export const setPaymentStatus = (data) => ({ type: SET_PAYMENT_STATUS, data });
export const setPaymentError = (data) => ({ type: SET_PAYMENT_ERROR, data });
export const set2FAviaOTP = (data) => ({ type: SET_2FA_OTP, data });

export const setStopQueryPolling = (data) => ({ type: STOP_QUERY_POLLING, data });

export const userTriggeredLeave = (data) => ({ type: USER_TRIGGERED_LEAVE, data });

export const setIsLoading = (data) => ({ type: SET_IS_LOADING, data });
export const setIsVerifying = (data) => ({ type: SET_IS_VERIFYING, data });
export const setIsGuest = (data) => ({ type: SET_IS_GUEST, data });
export const setIsSkipLogin = (data) => ({ type: SET_IS_SKIP_LOGIN, data });

export const updateTopUpData = (data) => ({ type: SET_TOPUP_DATA, data });